import ReportsDetailsQuarterOptions from './ReportsDetailsQuarterOptions';

export default ReportsDetailsQuarterOptions;
